import React from 'react';
import i18n from 'i18next';
import { isMobile } from '@ringcentral/rwc-utils/src/client-detection';
import RCFooter from '@ringcentral/rcv-ui/src/components/Footer/rc';
import CommonFooter from '@ringcentral/rcv-ui/src/components/Footer/common';

import { useBrandConfig } from '@low/utils/get-brand-config';
import { getIsRCBrand } from '@ringcentral/rwc-branding/src/utils';

function RCFooterRender() {
    const links = {
        // eslint-disable-next-line camelcase
        contact_us: {
            text: i18n.t('footer.links.contact_us.text'),
            href: i18n.t('footer.links.contact_us.href'),
        },
        about: {
            text: i18n.t('footer.links.about.text'),
            href: i18n.t('footer.links.about.href'),
        },
        partners: {
            text: i18n.t('footer.links.partners.text'),
            href: i18n.t('footer.links.partners.href'),
        },
        legal: {
            text: i18n.t('footer.links.legal.text'),
            href: i18n.t('footer.links.legal.href'),
        },
        privacy: {
            text: i18n.t('footer.links.privacy.text'),
            href: i18n.t('footer.links.privacy.href'),
        },
        // eslint-disable-next-line camelcase
        cookie_preferences: {
            key: 'cookie_preferences',
            text: i18n.t('footer.links.cookie_preferences.text'),
        },
        // eslint-disable-next-line camelcase
        site_map: {
            text: i18n.t('footer.links.site_map.text'),
            href: i18n.t('footer.links.site_map.href'),
        },
        BBB: {
            href: i18n.t('footer.links.BBB.href'),
        },
        skyhigh: {
            href: i18n.t('footer.links.skyhigh.href'),
        },
        trustare: {
            href: i18n.t('footer.links.trustare.href'),
        },
    };
    const mobileLinks = {
        BBB: {
            href: i18n.t('footer.links.BBB.href'),
        },
        skyhigh: {
            href: i18n.t('footer.links.skyhigh.href'),
        },
        trustare: {
            href: i18n.t('footer.links.trustare.href'),
        },
        // eslint-disable-next-line camelcase
        cookie_preferences: {
            text: i18n.t('footer.links.cookie_preferences.text'),
        },
    };
    return (
        <RCFooter
            logolink={i18n.t('footer.logolink')}
            copyright={i18n.t('footer.copyright', { year: new Date().getFullYear() })}
            links={!isMobile ? links : mobileLinks}
        />
    );
}

function CommonFooterRender() {
    const getConfig = useBrandConfig();
    const links = {
        legal: {
            text: i18n.t('footer.links.legal.text'),
            href: getConfig(['legalInfoPage']),
        },
        privacy: {
            text: i18n.t('footer.links.privacy.text'),
            href: getConfig(['privacyPolicyPage']),
        },
        // eslint-disable-next-line camelcase
        cookie_preferences: {
            text: i18n.t('footer.links.cookie_preferences.text'),
        },
    };
    const launchYear = getConfig(['launchYear']);
    const copyright = getConfig(['copyright']);
    const notificationTradeMark = getConfig(['notificationTradeMark']);
    // get from i18n file
    const ringCentralTradeMark = i18n.t('footer.ringCentralTrademark');

    const finalCopyright = `© ${
        launchYear ? launchYear + '-' : ''
    }${new Date().getFullYear()} ${copyright}\n${notificationTradeMark ?? ''}\n${
        ringCentralTradeMark ?? ''
    }`;

    const logoLink = i18n.t('footer.logolink');
    const poweredByLogoUrl = getConfig(['assets', 'poweredByLogoUrl']);

    return (
        <CommonFooter
            copyright={finalCopyright}
            links={links}
            logoLink={logoLink}
            poweredByLogoUrl={poweredByLogoUrl}
        />
    );
}

function Footer() {
    return getIsRCBrand() ? <RCFooterRender /> : <CommonFooterRender />;
}

export default Footer;
